/**
 * Copyright © Vaimo Group. All rights reserved.
 * See LICENSE_VAIMO.txt for license details.
 */

// Script that loads polyfills using polyfill-loader plugin
// Detects if polyfills are required and loads based on that

import 'polyfill-loader!core-js';

export default {}
